import styled from 'styled-components';

export default function Footer() {
  const x = new Date();
  return (
    <FooterComp>
      i<span style={{ color: 'rgb(59, 194, 149)'}}>Dey</span>Pay &copy; {x.getFullYear()}
    </FooterComp>
  )
}
const FooterComp = styled.div`
background: whitesmoke;
padding: 0.75rem 0;
text-align: center;
font-size: 0.8rem;
border-top: 0.6px solid slategray;
`;